import { useState, useEffect } from 'react';
import { usePlatform } from '~/services/platform';
import { DeviceInfo } from '~/services/platform/types';

/**
 * Hook to get device information including network details.
 * Fetches info once on mount and caches it.
 */
export function useDeviceInfo(): DeviceInfo | null {
  const platform = usePlatform();
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo | null>(null);

  useEffect(() => {
    let mounted = true;

    const fetchInfo = async () => {
      try {
        const info = await platform.getDeviceInfo();
        if (mounted) {
          setDeviceInfo(info);
          console.log('[useDeviceInfo] 📱 Device info loaded:', {
            platform: info.platform,
            model: info.model,
            networkName: info.networkName || 'N/A',
            ipAddress: info.ipAddress || 'N/A',
          });
        }
      } catch (err) {
        console.error('[useDeviceInfo] Failed to get device info:', err);
      }
    };

    fetchInfo();

    return () => {
      mounted = false;
    };
  }, [platform]);

  return deviceInfo;
}

export default useDeviceInfo;
